import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { CustomValidators } from '@core/custom-validators/validators';
import { TipoContatoEnum } from '@core/models/entidade';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { AreaAtuacaoService } from '@core/services/areaAtuacaoService';
import { CEPService } from '@core/services/cep.service';
import { CidadeService } from '@core/services/cidade.service';
import { DialogService } from '@core/services/dialog.service';
import { MessageService } from '@core/services/message.service';
import { PaisService } from '@core/services/pais.service';
import { PessoaService } from '@core/services/pessoa.service';
import { TipoContatoService } from '@core/services/tipocontato.service';
import { UFService } from '@core/services/uf.service';
import { VinculoService } from '@core/services/vinculo.service';
import { EntidadeSharedDataService } from '@modules/entidade/entidade-shared-data.service';
import { VinculoSharedDataService } from '@modules/vinculo/vinculo-shared-data.service';
import { addFormControls } from '@shared/util/util';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-contato-vinculo-form',
  templateUrl: './contato-vinculo-form.component.html',
  styleUrls: ['./contato-vinculo-form.component.scss'],
})
export class ContatoVinculoFormComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() vinculoForm!: FormGroup;
  @Input() contato: any;
  @Input() data: any;
  @Input() dataSet: any;
  @Input() paginaEntidade: boolean = false;
  @Input() paginaVinculo: boolean = false;
  @Input() paginaPessoa: boolean = false;
  @Output() contatoEmit = new EventEmitter<any>();

  enderecoPessoaLista: any[] = [];
  enderecoEntidadeLista: any[] = [];
  enderecoVinculoLista: any[] = [];

  contatoForm!: FormGroup;
  contatoEditado: any;
  contatos: any[] = [];
  cidadeList: any[] = [];
  tipoContatoList: any[] = [];
  paisesList: any[] = [];
  ufList: any[] = [];
  ddiList: any[] = [];
  nomePessoaList: any[] = [];
  bairrosList: any[] = [];
  showPessoaDelegada = false;
  nzFilterOption = (): boolean => true;

  @Input() dadosIdSelecionado!: any;
  @Input() pessoaIdSelecionado: any;
  @Input() entidadeIdSelecionado: any;
  previousEntidadeId: any;
  previousIdSelectPessoa: any;

  cep: string = '';
  tipoContatoSelecionada: any;
  // searchControl = new FormControl();
  acao!: RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  defaultPais: any;
  tipoContatoEnum = TipoContatoEnum;
  existeEndereco: boolean = false;
  cepToZipCode: boolean = false;
  enderecoEntidadePopulado: any;
  enderecoVinculoPopulado: any;
  endVinculoSet: boolean = false;
  endEntidadeSet: boolean = false;

  pessoaSelecionada: any;

  /** Fica visível por padrão; some se o usuário optar por usar o e-mail da pessoa. */
  usarEmailSubstituto: boolean = true;
  pessoaEmailInativo: boolean = false;

  constructor(
    private fb: FormBuilder,
    private ufService: UFService,
    private paisService: PaisService,
    private tipoContatoService: TipoContatoService,
    private route: ActivatedRoute,
    private cepService: CEPService,
    private messageService: MessageService,
    private cidadeService: CidadeService,
    private pessoaService: PessoaService,
    private entidadeSharedDataService: EntidadeSharedDataService,
    private vinculoService: VinculoService,
    private dialogService: DialogService
  ) { }

  ngAfterViewInit(): void {
    this.entidadeSharedDataService?.updateEmpresaEstrangeira$.subscribe(res => {
      if (res) {
        this.cepToZipCode = true;
      } else {
        this.cepToZipCode = false;
      }
    })
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.contato) {
      this.inserir = false;
      this.contatoForm.patchValue(this.contato);
    } else {
      this.inserir = true;
    }

    if (this.dataSet?.length) {
      this.existeEndereco = this.dataSet.some((item: any) => item.tipoContato?.id === TipoContatoEnum.ENDERECO);
    }

    const entidadeId =
      // this.data?.entidadeId ||
      this.dadosIdSelecionado?.entidadeId ||
      this.entidadeIdSelecionado;

    const idSelectPessoa =
      // this.data?.idSelectPessoa ||
      this.dadosIdSelecionado?.idSelectPessoa ||
      this.pessoaIdSelecionado;

    console.log("idSelectPessoa", idSelectPessoa);

    // if(entidadeId) {
    //   this.idEntidadeContatoControl?.setValue(entidadeId);
    // }

    // if(idSelectPessoa) {
    //   this.idVinculoContatoControl?.setValue(idSelectPessoa);
    // }

    if (typeof entidadeId === 'number' && entidadeId !== this.previousEntidadeId) {
      this.previousEntidadeId = entidadeId;

      this.vinculoService.listarContatoEntidadeVinculo(entidadeId, true).subscribe((data: any) => {
        this.enderecoEntidadeLista = data?.filter((item: any) => {
          if (item?.nomeComboVinculo?.trim() === "Principal -" || item?.nomeComboVinculo?.trim() === "Secundário -") {
            return false;
          }
          if (
            (item?.nomeComboVinculo?.startsWith("Principal - ") && item?.nomeComboVinculo?.trim() !== "Principal -") ||
            (item?.nomeComboVinculo?.startsWith("Secundário - ") && item?.nomeComboVinculo?.trim() !== "Secundário -")
          ) {
            return true;
          }
          return true;
        });

        const principal = this.dataSet?.find((item: any) => item.flagPrincipal);
        const enderecoEntidade = this.enderecoEntidadeLista.find((item: any) => item?.id === principal?.idEntidadeContatoSelect);


        if (enderecoEntidade && principal?.idEntidadeContatoSelect) {
          this.idEntidadeContatoControl?.setValue(enderecoEntidade?.id);
        }
      });
    }

    if (typeof idSelectPessoa === 'number' && idSelectPessoa !== this.previousIdSelectPessoa) {
      // Se já havia uma pessoa carregada antes (não é o assentamento inicial do valor vindo do
      // vinculoContato), o usuário trocou a pessoa do vínculo — o e-mail substituto antigo não
      // corresponde à nova pessoa e não deve ser mantido.
      if (this.previousIdSelectPessoa !== undefined) {
        this.emailControl?.reset();
      }
      this.previousIdSelectPessoa = idSelectPessoa;

      this.pessoaService.buscarPorId(idSelectPessoa).subscribe((pessoa: any) => {
        const principalContato = pessoa.pessoaContatos?.find((contato: any) => contato.flagPrincipal);
        if (principalContato) {
          this.contatoForm.patchValue({
            pessoaEmail: principalContato.email,
          })
          this.pessoaEmailInativo = !!principalContato.emailInativo;
        }
      })

      this.vinculoService.listarContatoVinculoVinculo(idSelectPessoa).subscribe((data: any) => {
        this.enderecoVinculoLista = data?.filter((item: any) => {
          if (item?.nomeComboVinculo?.trim() === "Principal -" || item?.nomeComboVinculo?.trim() === "Secundário -") {
            return false;
          }
          if (
            (item?.nomeComboVinculo?.startsWith("Principal - ") && item?.nomeComboVinculo?.trim() !== "Principal -") ||
            (item?.nomeComboVinculo?.startsWith("Secundário - ") && item?.nomeComboVinculo?.trim() !== "Secundário -")
          ) {
            return true;
          }
          return true;
        });;

        const principal = this.dataSet?.find((item: any) => item.flagPrincipal);
        const enderecoVinculo = this.enderecoVinculoLista.find((item: any) => item?.id === principal?.idVinculoContatoSelect);

        console.log('enderecoVinculo', this.enderecoVinculoLista);
        console.log('principal', principal);

        if (enderecoVinculo && principal?.idVinculoContatoSelect) {
          this.idVinculoContatoControl?.setValue(enderecoVinculo?.id);
        }
      });
    }
  }

  private checkUrl() {
    this.route.data.subscribe((data) => {
      this.acao = data['acao'];
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;
      this.visualizar = this.acao == RouteAction.Visualizar;
    });
  }

  ngOnInit() {
    this.checkUrl();
    this.carregarListas();
    this.construirForm();

    this.enderecoUf?.valueChanges.subscribe((val: any) => {
      if (val?.id) {
        this.cidadeService.getCidadesByUf(val.id).subscribe(data => {
          this.cidadeList = data.sort((a: { nome: string; }, b: { nome: any; }) => a.nome.localeCompare(b.nome));
        });
      } else this.cidadeList = [];
    })

    this.paisControl?.valueChanges.subscribe((val: any) => {
      if (val?.id) {
        this.contatoForm.get('ddi')?.setValue(val?.ddi);
      }
    });


    this.idEntidadeContatoControl?.valueChanges.subscribe((val: any) => {
      if (val) {
        const enderecoSet = this.enderecoEntidadeLista.find((item: any) => item?.id === val);
        if (enderecoSet) {
          const editObj = this.buildEditObj(enderecoSet);
          this.enderecoEntidadePopulado = editObj;
        }
      }
    });



    this.idVinculoContatoControl?.valueChanges.subscribe((val: any) => {
      if (val) {
        const enderecoSet = this.enderecoVinculoLista.find((item: any) => item?.id === val);
        if (enderecoSet) {
          const editObj = this.buildEditObj(enderecoSet);
          this.enderecoVinculoPopulado = editObj;
        }
      }
    });
  }

  mudarContatoEntidade() {
    this.mudarContato('Entidade', this.enderecoEntidadeLista, 'idEntidadeContatoSelect');
  }

  mudarContatoVinculo() {
    this.mudarContato('Vinculo', this.enderecoVinculoLista, 'idVinculoContatoSelect');
  }


  mudarContato(tipoContato: 'Entidade' | 'Vinculo', listaEndereco: any[], formControlId: string) {
    const isEntidade = tipoContato === 'Entidade';
    const endSet = isEntidade ? (this.endEntidadeSet = true) : (this.endVinculoSet = true);

    const enderecoSet = listaEndereco.find(
      (item: any) => item?.id === this.contatoForm.get(formControlId)?.value
    );

    if (enderecoSet) {
      const editObj = this.buildEditObj(enderecoSet);

      if (editObj?.ddi?.startsWith('+')) {
        const removeDdi = editObj?.ddi?.replace('+', '');
        const ddi = this.ddiList.find((ddi: any) => ddi?.ddi === removeDdi);
        editObj.ddi = ddi?.ddi;
      }

      delete editObj?.id;
      delete editObj?.idEntidadeContato;
      delete editObj?.idPessoaContato;
      delete editObj?.idVinculo;

      const { enderecoComplemento, telefone, email, pessoaEmail, ddi } = this.contatoForm.value;

      this.contatoForm.patchValue(editObj);

      const confirmMessage = `Deseja manter os dados: complemento, telefone e e-mail?`;

      if (endSet) {
        this.dialogService.confirm(confirmMessage, () => {
          this.contatoForm.patchValue({ enderecoComplemento, telefone, email, pessoaEmail, ddi });
        });
      } else {
        this.contatoForm.patchValue({ enderecoComplemento, telefone, email, pessoaEmail, ddi });
      }

      this.contatoForm.get(isEntidade ? 'idEntidadeContatoSelect' : 'idVinculoContatoSelect')?.setValue(enderecoSet?.id);

      if (isEntidade && this.enderecoVinculoPopulado) {
        this.idVinculoContatoControl?.setValue(null);
      } else if (!isEntidade && this.enderecoEntidadePopulado) {
        this.idEntidadeContatoControl?.setValue(null);
      }
    }
  }


  private buildEditObj(enderecoSet: any) {
    const editObj: any = {};

    if (this.acao === 'editar') {
      // Mantém os valores atuais dos campos telefone, email e complemento
      editObj.telefone = this.telefoneControl?.value;
      editObj.email = this.emailControl?.value;
      editObj.pessoaEmail = this.pessoaEmailControl?.value;
      editObj.enderecoComplemento = this.enderecoComplementoControl?.value;
    }

    // Atualiza os campos desejados, excluindo enderecoComplemento, telefone e email no editar
    Object.keys(enderecoSet).forEach(key => {
      if (this.acao === 'editar' && (key === 'enderecoComplemento' || key === 'telefone' || key === 'email')) {
        return;
      } else {
        editObj[key] = enderecoSet[key];
      }
    });

    // Formatação do telefone
    const telefoneSemCodArea = /^\d{4}[- ]?\d{4}$/;
    if (editObj?.telefone && telefoneSemCodArea.test(editObj.telefone.trim())) {
      editObj.telefone = `(00) ${editObj.telefone.replace(' ', '-')}`;
    }

    return editObj;
  }

  construirForm() {
    this.contatoForm = this.fb.group({
      id: [''],
      pais: [''],
      enderecoUf: [''],
      enderecoMunicipio: [''],
      enderecoBairro: [''],
      enderecoCep: [''],
      enderecoNumero: [''],
      enderecoLogradouro: [''],
      enderecoComplemento: [''],
      informacoesAdicionais: [''],
      ddi: [''],
      telefone: ['', CustomValidators.telefone],
      telefoneAdicional: [''],
      ddiFax: [''],
      fax: [''],
      faxAdicional: [''],
      siteUrl: [''],
      ramal: [''],
      tipoContato: ['', Validators.required],
      flagPrincipal: [true],
      email: [''],
      pessoaEmail: [''],
      escolherContato: [''],
      flagContatoDelegado: [false],
      pessoaDelegadaId: [''],
      idEntidadeContatoSelect: [],
      idPessoaContatoSelect: [],
      idVinculoContatoSelect: [],


    });

    this.contatoForm.valueChanges.subscribe(() => {
      this.emitirAlteracaoFormulario();
    });
  }

  emitirAlteracaoFormulario() {
    if (this.contatoForm.dirty) {
      // this.salvar();
      const objEnvio = { ...this.contatoForm.getRawValue() };
      this.contatoEmit.emit(objEnvio);
    }
  }

  carregarListas(): void {
    this.paisService.listar().subscribe((ddi: any) => this.ddiList = ddi);
    const requests: Record<string, any> = {
      tipoContato: this.tipoContatoService.listar(),
      enderecoUf: this.ufService.listar(),
      pais: this.paisService.listar(),
    };
    // Na tela de vínculo o nome da pessoa já vem do vínculo. O combo completo trava o overlay.
    if (!this.paginaVinculo) {
      requests['nomePessoa'] = this.pessoaService.pessoaCombo();
    }
    forkJoin(requests).subscribe((result: any) => {
      const tipoContato = result.tipoContato;
      const enderecoUf = result.enderecoUf;
      const pais = result.pais;
      const nomePessoa = result.nomePessoa;
      this.ufList = enderecoUf.sort((a: any, b: any) => a.nome.localeCompare(b.nome));
      this.paisesList = pais;
      if (nomePessoa) {
        this.nomePessoaList = nomePessoa;
      }
      if (this.contato && !this.paginaEntidade) {
        this.tipoContatoList = !this.existeEndereco ? tipoContato : tipoContato.filter((tipoContato: any) => tipoContato.id !== TipoContatoEnum.ENDERECO);
        this.contatoForm.patchValue(this.contato);
      } else {
        this.tipoContatoList = tipoContato;
      }

      const enderecoPrincipal = this.dataSet.find((item: any) => item.flagPrincipal);
      if (this.paginaVinculo && enderecoPrincipal) {
        this.contatoForm.patchValue(enderecoPrincipal);
        const tipoContatoDefault = tipoContato.filter((tipoContato: any) => tipoContato.id !== TipoContatoEnum.ENDERECO);
        this.contatoForm.get('tipoContato')?.setValue(tipoContatoDefault);
      }

      const defaultPais = this.paisesList.find(pais => pais.nome === 'Brasil');

      if (defaultPais) {
        this.contatoForm.patchValue({
          pais: defaultPais
        });
      }
    });
  }

  reset() {
    this.inserir = true;

    Object.keys(this.contatoForm.controls).forEach(key => {
      const control = this.contatoForm.get(key);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity({ emitEvent: false });
      }
    });

    this.contatoForm.reset();

    Object.keys(this.contatoForm.controls).forEach(key => {
      const control = this.contatoForm.get(key);
      if (control) {
        switch (key) {
          case 'pais':
          case 'enderecoUf':
          case 'enderecoMunicipio':
          case 'enderecoBairro':
          case 'enderecoCep':
          case 'enderecoLogradouro':
          case 'informacoesAdicionais':
          case 'siteUrl':
          case 'tipoContato':
            control.setValidators(Validators.required);
            break;
          case 'ddi':
            control.setValidators(Validators.pattern(/^\+[1-9]\d{0,2}$/));
            break;
          case 'email':
            control.setValidators([Validators.email, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')]);
            break;
          case 'pessoaEmail':
            control.setValidators([Validators.email, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')]);
            break;
          default:
            // Outros campos não possuem validação
            break;
        }
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  checkIfPrincipal(event: MouseEvent): void {
    const inputElement = event?.target as HTMLInputElement;

    if (!inputElement || inputElement.checked == null) {
      return;
    }

    const alreadyPrincipal = this.contatos.some(contato =>
      contato.flagPrincipal && contato !== this.contatoEditado
    );

    if (alreadyPrincipal && !this.contatoEditado.flagPrincipal) {
      this.messageService.warning('Já existe um contato marcado como principal. Não é possível marcar outro.');
      inputElement.checked = false;
    } else {
      // console.log('Checkbox is checked:', inputElement.checked);
      this.contatoEditado.flagPrincipal = inputElement.checked;
    }
  }



  onTipoContatoChange(value: any): void {
    if (value !== undefined) {
      this.tipoContatoSelecionada = this.tipoContatoList.find((tipo: any) => tipo?.id === value?.id);
      this.updateFormFields();
    }
  }

  updateFormFields(): void {
    this.resetValidators();

    switch (this.tipoContatoSelecionada?.id && !this.paginaEntidade) {
      case TipoContatoEnum.EMAIL:
        this.setEmailValidators();
        break;

      case TipoContatoEnum.TELEFONE:
        this.setTelefoneValidators();
        break;

      case TipoContatoEnum.ENDERECO:
        this.setEnderecoValidators();
        break;

      default:
        break;
    }

    this.setFormState();
    this.updateFormValidity();
  }

  resetValidators(): void {
    this.contatoForm.get('email')?.clearValidators();
    this.contatoForm.get('pessoaEmail')?.clearValidators();
    this.contatoForm.get('telefone')?.clearValidators();
    this.contatoForm.get('pais')?.clearValidators();
    this.contatoForm.get('enderecoUf')?.clearValidators();
    this.contatoForm.get('enderecoMunicipio')?.clearValidators();
    this.contatoForm.get('enderecoBairro')?.clearValidators();
    this.contatoForm.get('enderecoCep')?.clearValidators();
    this.contatoForm.get('enderecoLogradouro')?.clearValidators();
  }

  setEmailValidators(): void {
    this.contatoForm.get('email')?.setValidators([
      Validators.email,
      Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')
    ]);
    this.contatoForm.get('pessoaEmail')?.setValidators([
      Validators.email,
      Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')
    ]);
  }

  setTelefoneValidators(): void {
    this.contatoForm.get('telefone')?.setValidators([Validators.required]);

    if (this.existeEndereco) {
      const itemEndereco = this.dataSet.find((item: any) => item.tipoContato.id === TipoContatoEnum.ENDERECO);
      if (itemEndereco) {
        const ddiPais = this.ddiList.find((ddi: any) => ddi.id === itemEndereco.pais.id);
        if (ddiPais) {
          this.contatoForm.patchValue({ ddi: ddiPais.ddi });
        }
      }
    }
  }

  setEnderecoValidators(): void {
    this.contatoForm.get('pais')?.setValidators([Validators.required]);
    this.contatoForm.get('enderecoUf')?.setValidators([Validators.required]);
    this.contatoForm.get('enderecoMunicipio')?.setValidators([Validators.required]);
    this.contatoForm.get('enderecoBairro')?.setValidators([Validators.required]);
    this.contatoForm.get('enderecoCep')?.setValidators([Validators.required]);
    this.contatoForm.get('enderecoLogradouro')?.setValidators([Validators.required]);
  }

  updateFormValidity(): void {
    this.contatoForm.get('email')?.updateValueAndValidity();
    this.contatoForm.get('pessoaEmail')?.updateValueAndValidity();
    this.contatoForm.get('telefone')?.updateValueAndValidity();
    this.contatoForm.get('pais')?.updateValueAndValidity();
    this.contatoForm.get('enderecoUf')?.updateValueAndValidity();
    this.contatoForm.get('enderecoMunicipio')?.updateValueAndValidity();
    this.contatoForm.get('enderecoBairro')?.updateValueAndValidity();
    this.contatoForm.get('enderecoCep')?.updateValueAndValidity();
    this.contatoForm.get('enderecoLogradouro')?.updateValueAndValidity();
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    } if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    } else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    } else if (a?.id !== undefined && b !== undefined) {
      return a.id === b;
    } else if (a !== undefined && b?.id !== undefined) {
      return a === b?.id;
    } else if (a?.uf !== undefined && b?.sigla !== undefined) {
      // console.log('a.uf', a.uf);
      return a?.uf === b?.sigla
    } else if (a?.cidade !== undefined && b?.nome !== undefined) {
      // console.log('a.cidade', a.cidade);
      // console.log('b.nome', b.nome);
      return a?.cidade === b?.nome && a?.uf === b?.uf.sigla
    } else {
      return a === b;
    }
  }

  setFormState(): void {
    if (this.visualizar) {
      this.contatoForm.disable();
    }
  }

  salvar(): void {
    const flagPrincipal = this.contatoForm.get('flagPrincipal')?.value;
    if (flagPrincipal && this.dataSet.some((contact: { flagPrincipal: any; id: any; }) => contact.flagPrincipal
      && contact.id !== this.contatoForm.get('id')?.value)) {
      alert('Já existe um contato principal.');
    } else {
      if (this.contatoForm.valid) {
        let objEnvio = { ...this.contatoForm.getRawValue() };

        objEnvio.flagPrincipal = true;

        this.contatoEmit.emit(objEnvio);

        if (!this.paginaEntidade) {
          this.reset();
        }
      }
      // else {
      //   // console.log(this.contatoForm.value)
      //   this.messageService.error('Preencha os campos obrigatórios');
      // }
    }
  }

  onCepBlur(): void {
    const cep = this.contatoForm.get('enderecoCep')?.value;
    if (cep) {
      this.fetchCepData(cep);
    }
  }

  fetchCepData(cep: string): void {
    this.cepService.buscarEndereco(cep).subscribe(
      (data: any) => {
        if (!data.erro) {
          // console.log('CEP encontrado', data);

          // Encontrar a UF correspondente na lista de UFs
          const ufSelecionada = this.ufList.find(uf => uf.sigla === data.uf);
          // console.log('ufSelecionada', ufSelecionada);
          if (ufSelecionada && (!this.enderecoUf?.value || this.enderecoUf?.value.id !== ufSelecionada.id)) {
            this.enderecoUf?.patchValue(ufSelecionada); // Atualiza o valor do select de UF
            this.cidadeService.getCidadesByUf(ufSelecionada.id).subscribe(cidades => {
              this.cidadeList = cidades.sort((a: { nome: string; }, b: { nome: any; }) => a.nome.localeCompare(b.nome));
              this.setMunicipio(data); // Chamada para configurar a cidade após a atualização
            });
          } else {
            this.setMunicipio(data); // Caso a UF já esteja selecionada
          }

          this.contatoForm.patchValue({
            enderecoLogradouro: data.logradouro,
            enderecoBairro: data.bairro,
          });
        } else {
          console.error('CEP não encontrado');
        }
      },
      (error) => {
        console.error('Erro ao buscar o CEP', error);
      }
    );
  }

  setMunicipio(data: any): void {
    const municipioSelecionado = this.cidadeList.find(cidade =>
      cidade.nome === data.cidade && cidade.uf.sigla === data.uf
    );

    this.contatoForm.patchValue({
      enderecoMunicipio: municipioSelecionado || null,
      enderecoUf: municipioSelecionado?.uf || null,
    });
  }

  checkIfDelegado(event: boolean): void {
    this.showPessoaDelegada = event;
  }

  mostrarEmailSubstituto(): void {
    this.usarEmailSubstituto = true;
  }

  usarEmailDaPessoa(): void {
    this.usarEmailSubstituto = false;
    this.emailControl?.reset();
  }

  get paisControl() {
    return this.contatoForm.get('pais');
  }

  get tipoContatoId() {
    return this.contatoForm.get('tipoContato')?.value?.id;
  }

  get enderecoUf() {
    return this.contatoForm.get('enderecoUf');
  }

  get escolherContatoControl() {
    return this.contatoForm.get('escolherContato');
  }

  get enderecoMunicipioControl() {
    return this.contatoForm.get('enderecoMunicipio');
  }

  get idEntidadeContatoControl() {
    return this.contatoForm.get('idEntidadeContatoSelect');
  }

  get idVinculoContatoControl() {
    return this.contatoForm.get('idVinculoContatoSelect');
  }

  get telefoneControl() {
    return this.contatoForm.get('telefone');
  }

  get enderecoComplementoControl() {
    return this.contatoForm.get('enderecoComplemento');
  }

  get emailControl() {
    return this.contatoForm.get('email');
  }

  get pessoaEmailControl() {
    return this.contatoForm.get('pessoaEmail');
  }
}
